import React from 'react';
import { SxProps, TextField, Theme } from '@mui/material';
import { DesktopTimePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { Colors } from '../../../utils/theme';

interface IProps {
  id: string;
  label: string;
  value: Date | null;
  onChange: (value: Date | null, keyboardInputValue?: string | undefined) => void;
  sx?: SxProps<Theme>;
  errorMsg?: string | null;
  disabled?: boolean;
}

const EpraTimePicker: React.FunctionComponent<IProps> = ({
  id,
  label,
  value,
  onChange,
  sx,
  errorMsg,
  disabled = false
}: IProps) => {
  return (
    <MobileTimePicker
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          id={id}
          disabled={disabled}
          {...(errorMsg !== undefined && {
            error: errorMsg !== null,
            helperText: errorMsg ?? '',
            required: true
          })}
          sx={{
            color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main,
            backgroundColor: Colors.input_field_background,
            height: '36px',
            borderRadius: '9px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: 'none'
              }
            },
            ...sx
          }}
          InputProps={{
            ...params.InputProps
          }}
          FormHelperTextProps={{
            sx: {
              marginX: 0
            }
          }}
          InputLabelProps={{
            shrink: true,
            sx: {
              lineHeight: '22px',
              top: '-9px',
              color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main
            }
          }}
          inputProps={{
            ...params.inputProps,
            sx: {
              height: '36px',
              paddingLeft: '15px',
              paddingY: 0,
              color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main
            }
          }}
        />
      )}
    />
  );
};

export default EpraTimePicker;
